import React, { Component } from 'react';
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import {
  saveConfig,
  updatePercentileTrendsBy,
  updatePercentileTrendsPeriod,
  updatePercentileTrendsItems,
} from '../../FilterActions';
import RadioButton from '../../../RadioButton/RadioButton';

import './LocalPercentileTrends.scss';

const PERIODS = [
  { label: 'Week', value: 'week' },
  { label: 'Month', value: 'month' },
  { label: 'Quarter', value: 'quarter' },
];
const MIN_TRENDS_ITEMS = 2;

class LocalPercentileTrends extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typedTrendsItems: props.trendsItems,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.trendsItems !== this.props.trendsItems) {
      this.setState({ typedTrendsItems: this.props.trendsItems });
    }
  }

  handleTrendsByChange = ({ value }) => {
    this.props.updateTrendsBy(value, this.props.chart);
    this.props.saveConfig();
  };

  handleTrendsPeriodChange = ({ value }) => {
    this.props.updateTrendsPeriod(value, this.props.chart);
    this.props.saveConfig();
  };

  handleTrendsItemsChange = (event) => {
    this.setState({ typedTrendsItems: event.target.value });
  };

  handleTrendsItemsKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.target.blur();
    }
  };

  handleTrendsItemsBlur = () => {
    const trendsItems = Math.max(Math.round(+this.state.typedTrendsItems), MIN_TRENDS_ITEMS);
    this.setState({ typedTrendsItems: trendsItems });

    if (trendsItems !== this.props.trendsItems) {
      this.props.updateTrendsItems(trendsItems, this.props.chart);
      this.props.saveConfig();
    }
  };

  render() {
    const { trendsBy, trendsPeriod, trendsItems } = this.props;
    const isByItems = trendsBy === 'items';

    return (
      <div className="percentile-trends-control">
        <RadioButton
          id="percentile-trends-period"
          name="percentileTrendsBy"
          label="Time period"
          value="period"
          checked={!isByItems}
          onChange={this.handleTrendsByChange}
        />
        <p className="percentile-trends-control__description">Items completed during each selected period.</p>
        {!isByItems && (
          <div className="sublevel">
            {PERIODS.map((item) => (
              <RadioButton
                id={`percentile-trends-${item.value}`}
                key={item.value}
                name="percentileTrendsPeriod"
                label={item.label}
                value={item.value}
                checked={item.value === trendsPeriod}
                onChange={this.handleTrendsPeriodChange}
              />
            ))}
          </div>
        )}
        <div className="percentile-trends-control__option">
          <RadioButton
            id="percentile-trends-items"
            className="percentile-trends-control__radio"
            name="percentileTrendsBy"
            label="Fixed number of items"
            value="items"
            checked={isByItems}
            onChange={this.handleTrendsByChange}
          />
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="percentileTrendsItemsTooltip" className="tooltip_white max_width_200">
                Each point is a separate group of {trendsItems} completed items. Counting starts with the most recently
                completed item, so the oldest point can have fewer. When an item is completed, every group moves by one
                item.
              </Tooltip>
            }
            delay={{ show: 250, hide: 2000 }}
          >
            <span className="more_info" />
          </OverlayTrigger>
        </div>
        <p className="percentile-trends-control__description">
          Groups of {trendsItems} completed items, counted from the most recent.
        </p>
        {isByItems && (
          <div className="percentile-trends-control__items">
            <label htmlFor="percentile-trends-number">Number of items</label>
            <input
              id="percentile-trends-number"
              name="percentile-trends-number"
              type="number"
              min={MIN_TRENDS_ITEMS}
              step="1"
              className="form-control"
              value={this.state.typedTrendsItems}
              onChange={this.handleTrendsItemsChange}
              onKeyDown={this.handleTrendsItemsKeyDown}
              onBlur={this.handleTrendsItemsBlur}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateTrendsBy: (value, chart) => dispatch(updatePercentileTrendsBy(value, chart)),
    updateTrendsPeriod: (value, chart) => dispatch(updatePercentileTrendsPeriod(value, chart)),
    updateTrendsItems: (value, chart) => dispatch(updatePercentileTrendsItems(value, chart)),
  };
};

const mapStateToProps = (state) => {
  const chart = state.filters.chart;
  return {
    chart,
    trendsBy: state.filters[chart].percentileTrendsBy,
    trendsPeriod: state.filters[chart].percentileTrendsPeriod,
    trendsItems: state.filters[chart].percentileTrendsItems,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(LocalPercentileTrends);
export { connected as LocalPercentileTrends, LocalPercentileTrends as TestLocalPercentileTrends };
